import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useSettings } from '@/data/Settings';
import { getClientSideCommon } from '@/data/utils/getClientSideCommon';
import { transactionsPerson } from 'integration/generated/transactions';
import useSWR from 'swr';

const GET_INTEREST_DATA_KEY = 'GET_INTEREST_DATA_KEY';

const fetcherPersonAllPreferences =
	(pub: boolean) =>
	async (storeId: string, query: Record<string, unknown>, params: Record<string, unknown>) =>
		await transactionsPerson(pub).personAllPreferences(storeId, query, params);

export const useGetInterests = (args?: { code: string }) => {
	const { settings } = useSettings();
	const router = useNextRouter();
	const params = useExtraRequestParameters();

	const { storeId, langId } = getClientSideCommon(settings, router);

	const baseQuery = useSWR(
		storeId
			? [
					{ storeId, query: { langId, responseFormat: 'json', code: args?.code }, params },
					GET_INTEREST_DATA_KEY,
			  ]
			: null,
		async ([props]) => fetcherPersonAllPreferences(true)(props.storeId, props.query, props.params)
	);

	return {
		...baseQuery,
		data: baseQuery.data?.preferences || [],
	};
};
